/**
 * Try to get IC error from JSON.
 * Warning: multiple form of error reporting, think about standardizing in IC Rest API !
 * @param {*} response
 */
export function getIcError(response) {
  if (typeof response === 'string') {
    // Some exception mappers return simple strings
    return response;
  }
  if (typeof response === 'object') {
    // Some exception mappers return objects with message or errorMessage fields
    const {
      data,
      request,
      message,
      errorMessage = 'Un-known Error'
    } = response;

    if (data && data.errorMessage) {
      return data.errorMessage;
    }
    if (request) {
      // try to get and return messageError from responseText otherwise return responseText
      try {
        const obj = JSON.parse(request.responseText);
        return obj.errorMessage || obj.message || request.responseText;
      } catch (e) {
        if (
          (request.responseType === 'text' || request.responseType === '') &&
          request.responseText
        ) {
          return request.responseText;
        }
        if (request.statusText) {
          // blob json
          return request.statusText;
        }
      }
    }
    if (message) {
      return message;
    }
    return errorMessage;
  }
}
